"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var Overlay_1 = require("office-ui-fabric-react/lib/Overlay");
var Spinner_1 = require("office-ui-fabric-react/lib/Spinner");
var SyncOverlay_styles_1 = require("./SyncOverlay.styles");
var SyncOverlay_classNames_1 = require("./SyncOverlay.classNames");
var defaultRenderSync = function (props) {
    return React.createElement(Spinner_1.Spinner, { label: props.syncLabel || "Loading..." });
};
var SyncOverlay = /** @class */ (function (_super) {
    __extends(SyncOverlay, _super);
    function SyncOverlay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SyncOverlay.prototype.render = function () {
        if (this.props.sync.syncing) {
            var classNames = SyncOverlay_classNames_1.getClassNames(SyncOverlay_styles_1.getStyles(null, this.props.styles), this.props.className);
            var content = (this.props.onRenderSync || defaultRenderSync)(this.props);
            return (React.createElement(Overlay_1.Overlay, __assign({}, this.props, { className: classNames.root }),
                React.createElement("div", { className: classNames.content }, content)));
        }
        return null;
    };
    SyncOverlay = __decorate([
        mobx_react_1.observer
    ], SyncOverlay);
    return SyncOverlay;
}(React.Component));
exports.SyncOverlay = SyncOverlay;
